<my-content placeholder="navigation">
  <div id="ModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class="modal-dialog-FactSheet">
      <div class="modal-content">
        <div class="modal-header BlueHeader">
          <h4 class="Heading">{{ ModelFor }}</h4>
          <br />
          <button type="button" class="close" (click)="this[CallFunctionOnCloseModal]()" data-dismiss="modal">
            &times;
          </button>
        </div>
        <div class="modal-body col-sm-12 form-group">
          <iframe class="modal-frame" [src]="modalURL | safe"></iframe>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid">
    <div class="table-header-container">
      <div class="table-heading">
        {{ TypeHeader }}
      </div>
      <form #SearchNoticePlan="ngForm" [formGroup]="FormSearchNoticePlan"
        (ngSubmit)="onSearchNoticePlan(SearchNoticePlan.value)">
        <div class="d-flex">
          <div class="input-group">
            <input type="text" placeholder="Search here..." class="table-search-input form-control"
              formControlName="txtSearch" (input)="onSearch($event.target.value)" >
            <span class="input-group-btn">
              <button class="btn btn-primary" title="Search">
                <i class="fas fa-magnifying-glass"></i>
              </button>
            </span>
          </div>
          <button class="btn btn-outline-primary mx-2" routerLink="/decision/0" title="Create">
            <i class="fas fa-plus"></i>
          </button>
          <button class="btn btn-outline-primary " title="Advance Search" data-toggle="modal"
            (click)="OpenModal('ndc', '0', 'Filter', 'ReturnAdvanceSearch')" data-target="#ModalPopUP">
            <i class="fas fa-filter"></i>
          </button>
        </div>
      </form>
    </div>
    <div class="card table-container">
      <table class="custom-table">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Decision Point</th>
            <th>Facts</th>
            <th>Type Of Action</th>
            <th>Action Taken By</th>
            <th>Filing Party</th>
            <th>Opposite Party</th>
            @if (ReportType == 'process') {
            <th>Target Date</th>
            }
            @if (ReportType == 'plan') {
            <th>Responsible Manager</th>
            <th>Responsible Leader</th>
            <th>Exposure Amount</th>
            }
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <app-table-state
              [loading]="MsgType == 1"
              [error]="MsgType == 3 ? DisplayMessage ?? 'Something went wrong while fetching data.' : null"
              [empty]="filteredData?.length == 0"
              [rows]="10"
              [columns]="getColumnCount()">
            </app-table-state>
            @if (filteredData?.length > 0) {
              @for (mDtl of filteredData | paginate : { itemsPerPage: pageSize, currentPage: pageNumber }; track mDtl.id ?? i ; let i = $index) {
                <tr>
                  <td align="center">{{ (pageNumber - 1) * pageSize + i + 1 }}</td>
                  <td>{{ mDtl.Description }}</td>
                  <td>{{ mDtl.facts }}</td>
                  <td>{{ mDtl.ActionType }}</td>
                  <td style="word-break: break-all;" >{{ mDtl.ActionTakenBy }}</td>
                  <td>{{ mDtl.fillingParty }}</td>
                  <td>{{ mDtl.OppositeParty }}</td>
  
                  @if (ReportType == 'process') {
                    <td>{{ mDtl.TargetDt | date: "dd-MMM-yyyy" }}</td>
                  }
  
                  @if (ReportType == 'plan') {
                    <td>{{ mDtl.ManagerName }}</td>
                    <td>{{ mDtl.LeaderName }}</td>
                    <td>{{ mDtl.ExposureAmt }}</td>
                  }
  
                  @if (mDtl.NoticeID > 0) {
                    <td>
                      Convert in {{ mDtl.Noticetype }}<br />
                      <a target="_blank" routerLink="/gnotice/{{ mDtl.Noticetype }}//{{ mDtl.NoticeID }}">{{ mDtl.refno }}</a>
                    </td>
                  }
                  @else {
                    <td><span class="badge" [ngClass]="{'badge-open': mDtl.Status === 'Open','badge-hold': mDtl.Status === 'Hold','badge-close': mDtl.Status === 'Close'}" >{{ mDtl.Status }}</span></td>
                  }
  
                  <td>
                    <a class="icon-btn icon-btn-primary text-decoration-none" target="_blank" routerLink="/corporate-decision/{{ mDtl.ID }}"><i class="fa fa-pencil" aria-hidden="true"></i></a>
                  </td>
                </tr>
              }
            }
        </tbody>
      </table>
    </div>
    @if (MsgType == 0) {
      <div class="d-flex justify-content-between my-3 w-100">
          <div class="w-50">
            <app-rows-per-page
            [pageSize]="pageSize"
            [total]="totalRecords"
            [pageIndex]="pageNumber"
            (pageSizeChange)="onPageSizeChange($event)">
            </app-rows-per-page>
          </div>
        <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
      </div>
    }
  </div>
  <!-- <div class="col-sm-12" style="border-bottom: 1px solid #ccc"></div>

  <div class="col-sm-12" style="margin-top: 8px">
    <div
      class="col-sm-12"
      style="
        background-color: #eee;
        border: 1px solid #ddd;
        padding-top: 10px;
        padding-bottom: 10px;
      "
    >
      <div class="col-sm-4">
          <div class="col-sm-2 text-left height-34">Search</div>
          <div class="col-sm-6">
            <input
              class="form-control"
              placeholder="Search here"
              name="txtSearch"
              type="text"
              value=""
            />
          </div>
          <div class="col-sm-2">
            <input class="btn btn-primary btn-sm-12" type="submit" value="Go" />
          </div>
          <div class="col-sm-2">
            <a
              title="Advance Search"
              data-toggle="modal"
              (click)="OpenModal('ndc', '0', 'Filter', 'ReturnAdvanceSearch')"
              data-target="#ModalPopUP"
              ><i _ngcontent-efg-c1="" class="material-icons">
                filter_list
              </i></a
            >
          </div>
      </div>
      <div class="col-sm-6">&nbsp;</div>
      <div class="col-sm-2 d-flex justify-content-end">
        <a
          href="/#/decision/0"
          title="Create"
          style="cursor: pointer; color: #117a8b"
         
        >
          <i
            class="material-icons"
            style="
              cursor: pointer;
              padding: 7px;
              border: 1px solid #dfdfdf;
              border-radius: 4px;
              background: linear-gradient(
                20.39deg,
                rgb(255 255 255) 15.57%,
                rgb(255 255 255) 100.74%
              ) !important;
            "
            >add</i
          >
        </a>
      </div>
    </div>
  </div>

  <div class="col-sm-12" style="margin-top: 8px">
    <div
      class="col-sm-12 content-header"
    >
      <label >{{ TypeHeader }} </label>
    </div>
    <table width="100%" class="LMtable">
      <tr>
        <th>S.No.</th>
        <th width="12%">Decision Point</th>
        <th width="12%">Facts</th>
        <th>Type Of Action</th>
        <th>Action Taken By</th>
        <th>Filling Party</th>
        <th>Opposite Party</th>
        <th *ngIf="this.ReportType == 'process'">Target Date</th>
        <th *ngIf="this.ReportType == 'plan'">Responsible Manager</th>
        <th *ngIf="this.ReportType == 'plan'">Responsible Leader</th>
        <th *ngIf="this.ReportType == 'plan'">Exposure Amount</th>
        <th>Status</th>
        <th>Action</th>
      </tr>

      <tr *ngIf="this.MsgType == 1">
        <td colspan="80">
          <div class="d-flex align-items-center">
            <strong>Loading&nbsp;&nbsp;&nbsp;</strong>
            <div class="spinner-border" role="status"></div>
          </div>
        </td>
      </tr>
      <tr *ngIf="this.MsgType == 2">
        <td colspan="80">
          &nbsp;<span class="glyphicon glyphicon-info-sign"></span>&nbsp;
          <span>{{ DisplayMessage }}</span>
        </td>
      </tr>
      <tr *ngIf="this.MsgType == 3">
        <td colspan="80">
          <span class="Err">{{ DisplayMessage }}</span>
        </td>
      </tr>
      <ng-container *ngIf="this.MsgType == 0">
        <tr
          *ngFor="
            let mDtl of master
              | paginate : { itemsPerPage: 10, currentPage: pageNumber };
            let i = index
          "
        >
          <td align="center">{{ (pageNumber - 1) * 10 + i + 1 }}</td>
          <td>{{ mDtl.Description }}</td>
          <td>{{ mDtl.facts }}</td>
          <td>{{ mDtl.ActionType }}</td>
          <td>{{ mDtl.ActionTakenBy }}</td>
          <td>{{ mDtl.fillingParty }}</td>
          <td>{{ mDtl.OppositeParty }}</td>
          <td *ngIf="this.ReportType == 'process'">
            {{ mDtl.TargetDt | date : "dd-MMM-yyyy" }}
          </td>
          <td *ngIf="this.ReportType == 'plan'">{{ mDtl.ManagerName }}</td>
          <td *ngIf="this.ReportType == 'plan'">{{ mDtl.LeaderName }}</td>
          <td *ngIf="this.ReportType == 'plan'">{{ mDtl.ExposureAmt }}</td>
          <td *ngIf="mDtl.NoticeID > 0">
            Convert in {{ mDtl.Noticetype }}<br />
            <a
              target="_blank"
              routerLink="/gnotice/{{ mDtl.Noticetype }}//{{ mDtl.NoticeID }}"
              >{{ mDtl.refno }}</a
            >
          </td>
          <td *ngIf="mDtl.NoticeID == null">{{ mDtl.Status }}</td>
          <td *ngIf="this.ReportType == 'process'">
            <a target="_blank" routerLink="/corporate-decision/{{ mDtl.ID }}"
              >Process</a
            >
          </td>
          <td *ngIf="this.ReportType == 'plan'">
            <a target="_blank" class="mx-auto" routerLink="/corporate-decision/{{ mDtl.ID }}"
              >
              <i class="fa fa-pencil font-16 theme-icon "  aria-hidden="true"></i>
          </a>
          </td>
        </tr>
      </ng-container>
    </table>
    <br />
    <ng-container *ngIf="this.MsgType == 0">
      <pagination-controls
        (pageChange)="pageNumber = $event"
      ></pagination-controls>
    </ng-container>
  </div>

  <div><br />&nbsp;<br /></div> -->
</my-content>
<my-content placeholder="main"> </my-content>